/**
 * useThemeSync — mirrors the theme + tenant from the prefs slice onto the
 * document root as [data-theme] / [data-tenant], which is what @oxbo/tokens
 * CSS resolves against. Runs once on mount and on every change.
 */
import { useEffect } from "react";
import { applyThemeAttributes } from "@oxbo/tokens";
import { useAppSelector } from "@app/hooks";

export function useThemeSync(): void {
  const theme = useAppSelector((s) => s.prefs.theme);
  const tenant = useAppSelector((s) => s.prefs.tenant);

  useEffect(() => {
    applyThemeAttributes(theme, tenant);
  }, [theme, tenant]);
}
